/**
 * The tutorial prompt's english translations
 */
export const TUTORIAL_PROMPT_EN = {
  welcomeToNewsroomsAI: 'Welcome to newsrooms!',
  wouldYouLikeToWatchTutorial: 'Would you like to watch a quick tutorial video to get started?',
  skipForNow: 'Skip for now',
  watchTutorial: 'Watch tutorial'
}

/**
 * The tutorial prompt's german translation
 */
export const TUTORIAL_PROMPT_DE = {
  welcomeToNewsroomsAI: 'Willkommen bei newsrooms!',
  wouldYouLikeToWatchTutorial: 'Möchten Sie ein kurzes Tutorial-Video ansehen, um loszulegen?',
  skipForNow: 'Jetzt überspringen',
  watchTutorial: 'Tutorial ansehen'
}
